//Core
import React from "react";

//Styles
import "./styles.scss";

const DetailsCard = ({
  info = "info",
  image = "image",
  title = "title",
  color = "green",
  backgroundColor = "#DAECFF",
}) => {
  return (
    <div
      className="detailsCardContainer"
      style={{ color: `${color}`, backgroundColor: `${backgroundColor}` }}
    >
      <div className="topContainer">
        <div className="infoContainer">
          <p className="infoText" style={{ color: `${color}` }}>
            {info}
          </p>
        </div>
        <div className="textContainer" style={{}}>
          <p className="titleText">{title}</p>
        </div>
      </div>
      <div className="bottomContainerDetailsCard">
        <img src={image} alt="logo" width="60px" />
      </div>
    </div>
  );
};

export default DetailsCard;
